import { Suspense } from 'react'
import { MessageNode, MessageContent } from '@/types/message'
import widgetMap from '../template/widget'
import templateMap from '../template/biz-tmp'
import React from 'react'
import { chatCompletion } from '@/proxy-request/chat-completion'
import { observer } from 'mobx-react'
import Loading from '../template/widget/loading'

interface RenderMsgProps {
  msgNode: MessageNode
  msgContent: MessageContent
  onTypingComplete?: () => void
  onMount?: () => void
  useTypingComplete?: boolean
}

export const Renderer = observer((props: RenderMsgProps) => {
  const { msgNode, msgContent, onTypingComplete, ...rest } = props

  if (msgNode?.type === 'template') {
    const Widget: any = templateMap[msgNode?.template_id]
    if (!Widget) return null

    return (
      <Suspense
        fallback={
          <div>
            <Loading />
          </div>
        }
      >
        <div
        //  className="y-mt-12"
        >
          <Hoc {...rest} node={msgNode} msgContent={msgContent}>
            <Widget />
          </Hoc>
        </div>
      </Suspense>
    )
  }

  const Widget: any = widgetMap[msgNode?.type]

  if (!Widget) return null
  return (
    <Suspense
      fallback={
        <div>
          <Loading />
        </div>
      }
    >
      <Hoc
        {...rest}
        type={msgNode?.type}
        msgContent={msgContent}
        node={msgNode}
        onTypingComplete={onTypingComplete}
      >
        <Widget />
      </Hoc>
    </Suspense>
  )
})

const Hoc = (props: { [key: string]: any; onMount?: () => void }) => {
  const { msgNode, msgContent } = props

  const onTypingComplete = () => {
    if (msgNode?.type === 'text' || msgContent.type === 'link') {
      return props?.onTypingComplete?.()
    }
  }

  React.useEffect(() => {
    props?.onMount?.()
  }, [])

  const children = React.Children.map(props.children, child => {
    if (!React.isValidElement(child)) return null // 确保child是有效的React元素
    return React.cloneElement(child, {
      onTypingComplete: onTypingComplete,
      chatCompletion,
      ...props
    } as any)
  })

  return children
}
